<template>
  <div class="m-b-15">
    <WdsStack align-center gap-sm justify-start wrap>
      <WdsSelect
        v-model="invoiceStatus.data"
        :list="$options.invoiceStatusOptions"
        :placeholder="$t('Invoice status')"
        multi-select
      >
        <template #select-all-text>
          <WdsText :text="$t('Select all')" />
        </template>
      </WdsSelect>
      <WdsButtonGhost secondary class="tw-h-[38px]" @click="resetFilters">
        <div class="tw-my-auto">
          {{ $t('Reset filters') }}
        </div>
      </WdsButtonGhost>
    </WdsStack>
  </div>
</template>

<script>
import { WdsSelect, WdsStack, WdsButtonGhost, WdsText } from '@worksome/wds-components'
import { LocalStorageEncoder } from '@/utils/Encoders'

export default {
  invoiceStatusOptions: [
    { label: $t('Unpaid'), value: 'UNPAID' },
    { label: $t('Overdue'), value: 'OVERDUE' },
    { label: $t('Paid'), value: 'PAID' },
  ],
  components: {
    WdsText,
    WdsSelect,
    WdsStack,
    WdsButtonGhost,
  },
  props: {},
  data() {
    return {
      isResetting: false,
      invoiceStatus: new LocalStorageEncoder({
        queryPoint: 'invoice-status',
        decoder: this.decodeInvoiceOptionsFromUrl, // get from uri
        filter: (statuses) => statuses.map((status) => status.value), // pushing to uri
        defaultVal: null,
      }),
    }
  },
  computed: {
    filter() {
      return {
        invoiceStatus: this.invoiceStatus.data.map((status) => status.value),
        isBatched: true,
      }
    },
  },
  watch: {
    filter: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.$emit('filters-updated', newVal)
      },
    },
  },
  methods: {
    decodeInvoiceOptionsFromUrl(data) {
      const selections = data?.split(',').filter(Boolean) || []
      return this.$options.invoiceStatusOptions.filter((option) =>
        selections.some((selection) => selection === option.value),
      )
    },
    resetFilters() {
      this.isResetting = true
      setTimeout(() => {
        this.isResetting = false
      }, 600)
      this.invoiceStatus.data = []
    },
  },
}
</script>

<style scoped>
.inline-block {
  display: inline-block !important;
}

@-webkit-keyframes rotation {
  from {
    transform: rotate(359deg);
  }
  to {
    transform: rotate(0deg);
  }
}

.fa-undo.loading {
  animation: rotation 0.3s 1 ease-out;
}
</style>
